export const PINCODE_LIST_CACHE = 'CACHE.KEY.PINCODE.LIST'
export const AREA_LIST_CACHE = 'CACHE.KEY.AREA.LIST'
